<template>
  <v-container>
    <v-row>
      <v-col class="d-flex" cols="12" sm="4" md="2">
        <v-select
          :items="statuses"
          v-model="status"
          label="Status"
          dense
          @change="sendChangesIfValid"
          clearable
        ></v-select>
      </v-col>
      <v-col class="d-flex" cols="12" sm="4" md="2">
        <v-text-field
          v-model="number"
          label="Number"
          dense
          @change="sendChangesIfValid"
          clearable
        ></v-text-field>
      </v-col>
      <v-col class="d-flex" cols="12" sm="4" md="2">
        <v-text-field
          v-model="restaurantPlatformId"
          label="Restaurant Platform ID"
          dense
          @change="sendChangesIfValid"
          clearable
        ></v-text-field>
      </v-col>
      <v-col class="d-flex" cols="12" sm="4" md="2">
        <v-text-field
          v-model="platformOrderUuid"
          label="Platform Order ID"
          dense
          @change="sendChangesIfValid"
          clearable
        ></v-text-field>
      </v-col>
      <v-col class="d-flex" cols="12" sm="4" md="2">
        <v-menu
          ref="menu"
          v-model="menu"
          :close-on-content-click="false"
          :return-value.sync="date"
          transition="scale-transition"
          offset-y
          min-width="auto"
        >
          <template v-slot:activator="{ on, attrs }">
            <v-text-field
              v-model="date"
              label="Picker in menu"
              prepend-icon="mdi-calendar"
              readonly
              v-bind="attrs"
              v-on="on"
              clearable
            ></v-text-field>
          </template>
          <v-date-picker v-model="date" no-title scrollable @change="saveDate">
          </v-date-picker>
        </v-menu>
      </v-col>
    </v-row>
    <v-alert color="error" type="error" v-if="!isValid">
      You should either pick a date, a number, a restaurant platform id or a
      platform order id
    </v-alert>
  </v-container>
</template>

<script>
import moment from "moment";
import { PIPELINE_STATUSES, pipelineStatusFromQuery } from ".";

export default {
  data() {
    return {
      menu: false,
      status: pipelineStatusFromQuery(this.$route.query.status),
      valid: true,
      number: null,
      restaurantPlatformId: null,
      platformOrderUuid: null,
      date: new Date().toISOString().substr(0, 10),
      statuses: PIPELINE_STATUSES,
    };
  },
  watch: {
    "$route.query.status"(status) {
      const normalized = pipelineStatusFromQuery(status);
      if (normalized !== this.status) {
        this.status = normalized;
      }
    },
  },
  computed: {
    options() {
      return {
        status: this.status,
        number: this.number,
        platform: this.platform,
        platformOrderUuid: this.platformOrderUuid,
        restaurantPlatformId: this.restaurantPlatformId,
        date: moment(this.date).format("YYYY-MM-DD"),
      };
    },
    isValid() {
      return (
        this.number ||
        this.date ||
        this.platformOrderUuid ||
        this.restaurantPlatformId
      );
    },
  },
  methods: {
    saveDate(date) {
      this.$refs.menu.save(date);
      this.sendChangesIfValid();
    },
    sendChangesIfValid() {
      let status = this.status ? this.status : null;
      let number = this.number ? this.number : null;
      let date = this.date ? this.date : null;
      let platformOrderUuid = this.platformOrderUuid
        ? this.platformOrderUuid
        : null;
      let restaurantPlatformId = this.restaurantPlatformId
        ? this.restaurantPlatformId
        : null;
      let platform = this.platform ? this.platform : null;
      if (this.isValid) {
        this.$emit("refresh", {
          status,
          number,
          date,
          platformOrderUuid,
          restaurantPlatformId,
          platform,
        });
      }
    },
  },
};
</script>

<style></style>
